import { createSelector, createSlice } from "@reduxjs/toolkit";
import { normalizeUsers } from "../utils/users";

const initialState = {
  items: [],
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    upsertUser(state, action) {
      const user = action.payload;
      const items = normalizeUsers(state.items);
      const index = items.findIndex((item) => item.id === user.id);
      if (index >= 0) {
        items[index] = { ...items[index], ...user };
      } else {
        items.unshift(user);
      }
      state.items = items;
    },
    removeUsers(state, action) {
      const ids = new Set(action.payload);
      const items = normalizeUsers(state.items).filter((user) => !ids.has(user.id));
      state.items = items;
    },
    setUsers(state, action) {
      const items = normalizeUsers(action.payload);
      state.items = items;
    },
  },
});

export const { upsertUser, removeUsers, setUsers } = usersSlice.actions;
export const selectUsers = (state) => state.users.items;
export const selectActiveUserCount = createSelector(
  [selectUsers],
  (items) => normalizeUsers(items).filter((user) => user.status === "active").length,
);
export default usersSlice.reducer;
